<template>
  <SubContent h="6rem" w="10rem"  @back="showTip = true">
    <template v-slot:nav_left>
      {{$t('createMatchPlan')}}
    </template>
    <div class="tutorial_wrap">
      <template v-if="flashFlag">
        <object
          id="session_tool"
          type="application/x-shockwave-flash"
          name="session_tool"
          align="middle"
          width="100%"
          height="100%"
          :data="`${hostUrl}/uploads/flash-tool/yioks-preloader.swf?revision=1463`"
          style="margin-top:0px !important;">
          <param name="quality" value="high">
          <param name="bgcolor" value="#ffffff">
          <param name="play" value="false">
          <param name="loop" value="false">
          <param name="wmode" value="opaque">
          <param name="scale" value="showall">
          <embed wmode="opaque"/>
          <param name="menu" value="true">
          <param name="devicefont" value="false">
          <param name="salign" value="">
          <param name="allowscriptaccess" value="sameDomain">
          <param name="allowfullscreen" value="true">
          <param name="allowFullScreenInteractive" value="true">
          <param name="base" value="images/flash">
          <param
            name="flashvars"
            :value="`selectedMovie=${hostUrl}/uploads/flash-tool/yioks-football-editor.swf&amp;xmlRequestFile=${defaultUrl}%26fixtureId=${fixtureId}%26fixtureName=${fixtureName}%26sessionKind=practice%26sessionType=Match%26createSessionToken=${sessionToken}%26goToUrl=${gotoUrl}&amp;globalRequestFile=${hostUrl}/uploads/flash-tool/zh/global_data_1.xml&amp;revision=1463`">
        </object>
      </template>
      <template v-if="flashTipsFlag">
        <flash-tips></flash-tips>
      </template>
      <yioks-tip :showTip="showTip" :tipMsg="$t('waivedSubmission')" @callback='back' />
    </div>
  </SubContent>
</template>

<script>

import { flashCheck, uuid } from '@/utils/yioks_filter'

export default {
  components: {
    'SubContent': () => import('@/components/layout/SubContent'),
    'FlashTips': () => import('@/components/FlashTips')
  },
  data () {
    return {
      flashFlag: false,
      flashTipsFlag: false,
      sessionToken: uuid() + uuid(),
      fixtureId: this.$route.query.uuid,
      fixtureName: this.$route.query.squadName,
      defaultUrl: '/api/editor/defaultXml?defaultXmlType=match',
      gotoUrl: '',
      showTip: false,
      hostUrl: process.env.VUE_APP_URL
    }
  },
  created () {
    this.flashFlag = flashCheck()
    this.flashTipsFlag = !this.flashFlag
    this.gotoUrl = 'api/zuxie/guozi/teaching/matchRedirectUrl?createSessionToken=' + this.sessionToken
  },
  methods: {
    back (isSure) {
      if (isSure) {
        this.$router.go(-1)
      }
      this.showTip = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tutorial_wrap
    flex 1
</style>
